module.exports = __webpack_public_path__ + "static/img/Arena Breakout.a3492127.png";